<template>
  <div class="bankNameField">
    <div class="label">
      <span class="required">*</span>{{ label }}
    </div>
    <div class="value" @click="onSelectBank">
     <span class="bankName" v-if="bankName">{{ bankName }}</span>
     <span class="placeholder" v-else>{{ placeholder }}</span>
     <img class="oride-icon" src="@/assets/style/oride-icon.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BankNameField",
  components: {},
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "输入您的开户行",
    },
  },
  data() {
    return {
    };
  },
  async mounted() {},
  methods: {
    onSelectBank() {
      this.$router.push({ name: "selectBank" })
    },
  },
  watch: {
    value(newVal, oldVal) {
      if(newVal != oldVal){
        this.$store.commit("setBankName", newVal);
      }
    }
  },
  computed: {
    bankName() {
      if(this.$store.getters.bankName){
       this.$emit("input", this.$store.getters.bankName);
      }
      return this.$store.getters.bankName;
    },
  },
};
</script>

<style scoped lang="scss">
.bankNameField {
  display: flex;
  align-items: center;
  padding: 12px 0px;
}
.label {
  font-size: 14px;
  color: #333333;
  width: 80px;
  .required {
    color: #ff4444;
  }
}
.value {
  flex: 1;
  display: flex;
  align-items: center;
  height: 38px;
  border-radius: 17px;
  font-size: 14px;
  padding: 0px 12px;
  background: #F8F8F8;
  justify-content: space-between;
  .bankName {
    color: #333333;
  }
  .placeholder {
    color: rgba(170,170,170,0.67);
  }
  .oride-icon {
    height: 16px;
  }
}
</style>
